import { NgModule } from '@angular/core';
import { ManualFocusDirective } from './manual-focus.directive';

@NgModule({
  imports: [],
  exports: [ManualFocusDirective],
  declarations: [ManualFocusDirective],
  providers: [],
})
export class ManualFocusModule { }
